import { useState } from "react"
import HtmlParser from "react-html-parser"
import { metadata, SVOD_BLOCK_TEXT, SVOD_BLOCK_TEXT_LONG } from "lacinetek-common/src/metadata"

import { BlockQuote } from "components/subscription/block-quote"
import classNames from "classnames"
import { useTranslation } from "lib/i18n/translation"
import { readMore } from "lib/gtm/interactions"

export const Info = ({ block }) => {
	const longText = metadata(block, SVOD_BLOCK_TEXT_LONG)
	const shortText = metadata(block, SVOD_BLOCK_TEXT)

	return (
		<section>
			<BlockQuote block={block} />
			{!!shortText && HtmlParser(shortText)}
			{!!longText && <CollapsibleText text={longText} columns={3} block={block} />}
		</section>
	)
}

const CollapsibleText = ({ text, columns, block }) => {
	const [displayLongText, setDisplayLongText] = useState(false)
	const { c } = useTranslation()

	const handleToggleTextDisplay = (event) => {
		event.preventDefault()
		if (displayLongText === false) {
			readMore(block.id)
		}
		setDisplayLongText(previous => !previous)
	}

	return (
		<>
			<div className={classNames("collapsible", { "active": displayLongText })} >
				<div className="columnizer" data-columns={columns}>
					{HtmlParser(text)}
				</div>
			</div>
			<p className="centered">
				<a
					href="#edito-svod-full"
					title={displayLongText? c("reduce-text") : c("read-more")}
					data-collapse-close="Réduire le texte"
					data-collapse-open="Lire la suite"
					className={classNames(
						"collapsible-toggle button small active",
						{ "icon-more": !displayLongText },
						{ "icon-less": displayLongText },
						{ "active": displayLongText }
					)}
					onClick={handleToggleTextDisplay}
				>
					{displayLongText? c("reduce-text") : c("read-more")}
				</a>
			</p>
		</>
	)
}
